import { useAPI, useAuthenticatedAPI } from '../../../state';
var SEATS_API = '/api/orgConfig/seats';
var SEATS_STATUS_API = '/api/orgConfig/seats/status';
var SEAT_API = '/api/orgConfig/seats/{id}';
var SEATS_CAPACITY_API = '/api/orgConfig/seats/capacity';
// Keep in sync with MIN/MAX_ALLOCATED_SEATS in the API's seats DTO. A reservation needs at least
// one seat, and the upper bound stays well under the signed-int DB column to avoid overflow.
export var MIN_ALLOCATED_SEATS = 1;
export var MAX_ALLOCATED_SEATS = 1000000;
export var useSeatAllocationsAPI = function (configVersionId) {
    return useAPI("".concat(SEATS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigSeats-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useSeatAllocationsByClientAPI = function (configVersionId) {
    return useAPI("".concat(SEATS_API, "?configVersionId={configVersionId}&view=client"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigSeatsByClient-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useSeatAllocationsByLocationAPI = function (configVersionId) {
    return useAPI("".concat(SEATS_API, "?configVersionId={configVersionId}&view=location"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigSeatsByLocation-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useCreateSeatAllocationAPI = function () { return useAuthenticatedAPI(SEATS_API, {}, 'POST'); };
export var useBatchCreateSeatAllocationAPI = function () {
    return useAuthenticatedAPI("".concat(SEATS_API, "/batch"), {}, 'POST', { key: 'orgConfigSeatBatchCreate' });
};
export var useUpdateSeatAllocationAPI = function () {
    return useAuthenticatedAPI(SEAT_API, {}, 'PUT', { key: 'orgConfigSeatUpdate' });
};
export var useBatchUpdateSeatAllocationAPI = function () {
    return useAuthenticatedAPI(SEATS_API, {}, 'PATCH', { key: 'orgConfigSeatBatchUpdate' });
};
export var useDeleteSeatAllocationAPI = function (id) {
    return useAuthenticatedAPI(SEAT_API, { id: id }, 'DELETE', { key: "orgConfigSeatDelete-".concat(id) });
};
export var useDeleteSeatAllocationMutationAPI = function () {
    return useAuthenticatedAPI(SEAT_API, {}, 'DELETE', { key: 'orgConfigSeatDelete' });
};
export var useBatchDeleteSeatAllocationAPI = function () {
    return useAuthenticatedAPI("".concat(SEATS_API, "/batch-delete"), {}, 'POST', { key: 'orgConfigSeatBatchDelete' });
};
export var useSeatsStatusAPI = function (configVersionId) {
    return useAPI("".concat(SEATS_STATUS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "seatsStatus-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useSeatsCapacityAPI = function (configVersionId) {
    return useAPI("".concat(SEATS_CAPACITY_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "seatsCapacity-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
